<template>
  <wrap @hide="handle_hide" ref="wrap" :title="title">
    <p class="top_btn" v-if="tab > 1 && !loading"><a href="javascript:;" @click="back">返回</a></p>
    <CTable v-if="!loading" :head="head" :body="body">
      <template slot-scope="{data}" slot="lottery_name">
        <a href="javascript:;" v-if="tab===1" @click="openDetail(data)">{{data.lottery_name}}</a>
        <span v-else>{{data.lottery_name}}</span>
      </template>
      <template slot="class2_class3" slot-scope="{data}">
        <span>{{data.class2}}</span>
        <Popover placement="right" trigger="click" v-if="data.class4!=null">
            <Table border :data="data.class4" style="max-height:400px;overflow:auto">
              <TableColumn width="150" property="class3" label="号码">
                <template slot-scope="scope">
                  <span :class="[scope.row.is_win==1 ? 'red' : '']">{{scope.row.class3}}</span>
                </template>
              </TableColumn>
              <TableColumn width="80" property="odds" label="中二赔率" v-if="data.class2=='三中二' || data.class2=='三中二X'">
                <template slot-scope="scope">
                  <span :class="[scope.row.is_win==1&&scope.row.odds_option==0 ? 'red' : '']">{{scope.row.odds}}</span>
                </template>
              </TableColumn>
              <TableColumn width="80" property="odds" label="中特赔率" v-else-if="data.class2=='二中特' || data.class2=='二中特X'">
                <template slot-scope="scope">
                  <span :class="[scope.row.is_win==1&&scope.row.odds_option==0 ? 'red' : '']">{{scope.row.odds}}</span>
                </template>
              </TableColumn>
              <TableColumn width="80" property="odds" label="赔率" v-else>
                <template slot-scope="scope">
                  <span :class="[scope.row.is_win==1 ? 'red' : '']">{{scope.row.odds}}</span>
                </template>
              </TableColumn>
              <TableColumn width="80" property="odds" label="中三赔率" v-if="data.class2=='三中二' || data.class2=='三中二X'">
                <template slot-scope="scope">
                  <span :class="[scope.row.is_win==1&&scope.row.odds_option==1 ? 'red' : '']">{{scope.row.odds2}}</span>
                </template>
              </TableColumn>
              <TableColumn width="80" property="odds" label="中二赔率" v-else-if="data.class2=='二中特' || data.class2=='二中特X'">
                <template slot-scope="scope">
                  <span :class="[scope.row.is_win==1&&scope.row.odds_option==1 ? 'red' : '']">{{scope.row.odds2}}</span>
                </template>
              </TableColumn>
            </Table>
            <p style="text-align: right;margin-top: 5px;">共 <span class="red">{{data.zs}}</span> 注，每注 <span class="red">{{data.money2}}</span> 元<span v-if="data.status!=1">，中 <span class="red">{{data.win_zs}}</span> 注</span></p>
            <span slot="reference"><span class="hasClass4">{{data.class3}}</span></span>
          </Popover>
          <span class="blue" v-else>{{data.class3}}</span>
      </template>
      <template slot-scope="{data}" slot="odds_odds2">
        <span v-if="data.class2=='三中二'||data.class2=='二中特' || data.class2=='三中二X'||data.class2=='二中特X'">{{data.odds}}/{{data.odds2}}</span>
        <span v-else>{{data.odds}}</span>
      </template>
      <template slot-scope="{data}" slot="status">
        <span class="green" v-if="data.status==1 || data.status==2">有效</span>
        <span class="red" v-else-if="data.status==3">取消
          <p v-if="data.cancel_time!=''">{{data.cancel_time}}</p>
        </span>
      </template>
    </CTable>
    <p v-else class="block_tip">正在加载...</p>
  </wrap>
</template>

<script>
  import Wrap from './wrap';
  import mixin from './mixin';
  import CTable from './table';
  import {unsettle, unsettle2} from '../../service/report';
  import {Popover,Table,TableColumn,} from "element-ui";

  export default {
    name: "c_table",
    mixins: [mixin],
    data() {
      return {
        // 结算状态
        tab: 1,
        list: [],
        detail: [],
        loading: false
      };
    },
    methods: {
      sum(list, key) {
        const f = n => Math.round(n * 10000) / 10000;
        return list.reduce((p, n) => f(p + n[key]), 0);
      },
      back() {
        this.tab--;
      },
      // 关闭时
      handle_hide() {
        this.tab = 1;
      },
      // 打开详情
      async openDetail(item) {
        this.loading = true;
        this.tab++;
        const info = await unsettle2(item.lottery_type);
        this.loading = false;
        if (info.result !== 'ok') return this.$Message.error(info.msg);
        this.detail = info.data || [];

        this.detail.push({
          order_id: '总计',
          money: this.sum(this.detail, 'money')
        });
      },
      // 组件默认方法
      async loadInfo() {
        this.loading = true;
        const info = await unsettle();
        if (info.result === 'ok') {
          this.list = info.data;
        } else {
          this.$Message.error(info.msg);
        }

        this.loading = false;
      }
    },
    computed: {
      head() {
        // 主页
        return this.tab === 1 ? [
          {label: '彩票类型', value: 'lottery_name'},
          {label: '注数', value: 'count'},
          {label: '下注金额', value: 'bet_money'},
          {label: '有效金额', value: 'bet_money_real'}
          // 详情
        ] : [
          {label: '订单号', value: 'order_id'},
          {label: '时间', value: 'date_time'},
          {label: '彩种名称', value: 'lottery_name'},
          {label: '期号', value: 'period'},
          {label: '投注内容', value: 'class2_class3'},
          {label: '赔率', value: 'odds_odds2'},
          {label: '投注金额', value: 'money'},
          {label: '退水', value: 'rebate'},
          {label: '可赢金额', value: 'win'},
          {label: '状态', value: 'status'}
        ];
      },
      body() {
        return this.tab === 1 ? this.list : this.detail;
      }
    },
    components: {Wrap, CTable,Popover,Table,TableColumn},
  }
</script>
<style>
.el-table td,.el-table th{padding:unset !important;}
.el-table .cell{line-height:unset !important;}
.el-table .cell span{
  line-height: 10px;
  font-size: 10px;
}
  .hasClass4 {
    border-bottom: 1px dashed #1e90ff;
    color: #1e90ff;
    font-weight: bold;
    display: inline-block;
    cursor: pointer;
  }
</style>
<style lang="stylus" scoped>
  .block_tip {
    font-size: 14px;
  }

  .top_btn {
    font-size: 14px;
    text-align: right;
    line-height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/QC14.vue